import { DependencyList, useEffect } from 'react';

import { scrollToTop } from 'helpers';

export const useScrollToTop = (
  deps?: DependencyList,
  options?: ScrollToOptions
) => {
  useEffect(() => {
    scrollToTop(options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
